import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import App from './App'
import { enforceRememberPolicy } from './stores/auth'
import './i18n'                         // init i18n before App renders
import './styles/globals.css'

// Drop a non-"remember me" session if the browser was closed (PULSE-203).
enforceRememberPolicy()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // We refetch on focus mostly via explicit refetch() calls in pages;
      // disable the global behaviour to avoid surprise spinners while
      // alt-tabbing between admin and the bot terminal.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
